import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';

import { AuthLayout } from '@cold-ambulance/layout';
import { buttonVariants, cn } from '@cold-ambulance/shadcn';
import { SuccessIcon } from '@cold-ambulance/ui';

export default function PasswordReset() {
  const { t } = useTranslation();
  return (
    <AuthLayout
      className="bg-[#F8F8F8]"
      title={
        <div className="flex flex-col items-center justify-center gap-y-6">
          <SuccessIcon />
          <p>{t('forgotPassword.passwordChangedTitle')}</p>
        </div>
      }
      subtitle={
        <p className="text-center">{t('forgotPassword.useNewPassword')}</p>
      }
      center={true}
    >
      <Link to={'/signin'} className={cn(buttonVariants(), 'mt-3 w-full')}>
        {t('common.signIn')}
      </Link>
    </AuthLayout>
  );
}
